import { IonGrid } from "@ionic/react";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

const RadialBarComponent: React.FC = () => {
  Chart.register(ArcElement, Tooltip, Legend);

  const data = {
    labels: ["Charging", "Discharging", "Charge Complete", "Idle"],
    datasets: [
      {
        data: [100, 0, 0, 0],
        backgroundColor: ["#004b25", "#ff4961", "#39b54a", "#ffd534"],
        hoverBackgroundColor: ["#004b25", "#ff4961", "#39b54a", "#ffd534"],
        borderWidth: 2,
      },
    ],
    title: "ALl ba",
  };
  return (
    <IonGrid>
      <Doughnut
        data={data}
        options={{
          maintainAspectRatio: false,
          responsive: true,
        }}
      />
    </IonGrid>
  );
};

export default RadialBarComponent;
